import React from 'react';

const OurStory = () => {
  return (
    <section className="home-our-story bg-250147">
      <div className="container-lg inner-container">
        <div className="row">
          <div className="col-md-6">
            <img src="assets/img/b2b-img.png" alt="b2b" />
          </div>
          <div className="col-md-6 text-white">
            <h4 className="ll1">Our Story</h4>
            <h1 className="ll2">B2B Digital Marketing Agency.</h1>
            <h6 className="ll3"><i>Come for the marketing. Stay for the network.</i></h6>
            <p>We believe that effective B2B digital marketing is more than just a well-executed campaign; it's about building a network. When you partner with Purplepatch, you're not just getting industry-leading marketing expertise – you're gaining
              access to a network of actual buyers. We bridge the gap between you and your ideal clients, providing introductions that can transform potential leads into loyal customers.</p>
            <a href="#" className="arrow-1 a-arrow"></a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
